export enum MessageType {
    SUCCESS, INFO, WARNING, ERROR
  }
  